<div class="not-found">
   <div class="not-found-message">
      <div class="message-sub-heading"> Oops! </div>
      <div class="message-text">
         <h2>{{ message }}</h2>
         <a mat-raised-button [routerLink]="['/']">Back to Home</a>
      </div>
   </div>
   <div class="not-found-heading">
      <h1>404</h1>
   </div>
</div>
